import $ from 'jquery';
import Swiper, { Navigation, Pagination, Thumbs, FreeMode } from 'swiper';

export default class SingleSpace {
    constructor() {
        this.spaceGallerySwiper();
    }

    spaceGallerySwiper() {
        // configure Swiper to use modules
        Swiper.use([Navigation, Pagination]);

        // init Swiper:
        const singleSpaceGallerrySwiper = new Swiper('[data-swiper-element="singleSpaceGallerry"]', {
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
                dynamicMainBullets: 3
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
        const $singleSpaceGallerrySwiperThumbs = $('[data-swiper-thumb-for="singleSpaceGallery"]');
        $singleSpaceGallerrySwiperThumbs.eq(0).addClass('active');
        singleSpaceGallerrySwiper.on('slideChange', (swiper) => {
            $singleSpaceGallerrySwiperThumbs.removeClass('active').eq(swiper.realIndex).addClass('active');
        });
        $singleSpaceGallerrySwiperThumbs.on('click', (e) => {
            const i = $(e.currentTarget).index() + 1;
            singleSpaceGallerrySwiper.slideTo(i, 0, false);
        });
    }
};
